export default __webpack_public_path__ + "static/media/coinbase-wallet.481fc945.svg";